// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ConversationParticipantProfilePhoto_participant_graphql = require("../../__generated__/ConversationParticipantProfilePhoto_participant_graphql.bs.js");

let convertFragment = ConversationParticipantProfilePhoto_participant_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__ParticipantProfilePhoto(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "tiny";
  let participant = RescriptRelay_Fragment.useFragment(ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, props.participant);
  switch (participant.__typename) {
    case "Agent" :
      return JsxRuntime.jsx(Avatar__Jsx3.make, {
        src: Stdlib_Option.getOr(Stdlib_Option.map(participant.profilePhoto, param => param.url), AvatarSrcUrl.place_holder),
        name: participant.displayName,
        size: size
      });
    case "AnonymousConversationParticipant" :
      return JsxRuntime.jsx(Avatar__Jsx3.make, {
        src: AvatarSrcUrl.place_holder,
        name: "Agent chose to hide their name",
        size: size
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`unselected union member ` + participant._0 + ` on conversation participant`);
  }
}

let placeholder = AvatarSrcUrl.place_holder;

let make = Conversation__ParticipantProfilePhoto;

exports.Fragment = Fragment;
exports.placeholder = placeholder;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
